module.exports = __webpack_public_path__ + "img/people26.aab9d702.png";